// extracted by mini-css-extract-plugin
export default {"codeBlock":"CodeBlock_codeBlock__nUczJ","container":"CodeBlock_container__z96sy","copyBtn":"CodeBlock_copyBtn__ZGMMu","copied":"CodeBlock_copied__BMM-X"};